import { render, staticRenderFns } from "./compupload.vue?vue&type=template&id=a0f04cf2"
import script from "./compupload.vue?vue&type=script&lang=js"
export * from "./compupload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports